<template>
  <v-container
    no-gutters
  >
  <v-row
    no-gutters
  >
    <v-col
      cols="12"
      class="pa-0"
      v-if="getSelectedShipment != null"
    >
      <component :key="getSelectedShipmentID" :is="`detail_${selectedView}`"></component>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ShipmentsOverviewContext from '@/components/shipments/new/ShipmentsOverviewContext'
  import ShipmentsScheduleContent from '@/components/shipments/new/schedule/ShipmentsScheduleContent'
  import ShipmentsGroupByDayMap from '@/components/shipmentsByDay/map/ShipmentsGroupByDayMap'
  import ShipmentsDropsContent from '@/components/shipments/new/drops/ShipmentsDropsContent'
  import ShipmentsQuoteContent from '@/components/shipments/new/quoting/ShipmentsQuoteContent'
  export default {
    name: 'ShipmentsGroupByDayDetail',
    components: {
      'detail_schedule': ShipmentsScheduleContent,
      'detail_quote': ShipmentsQuoteContent,
      'detail_map': ShipmentsGroupByDayMap,
      'detail_drops': ShipmentsDropsContent
    },
    props: {
      selectedView: { type: String, default: null }
    },
    computed: {
      ...mapGetters({
        getSelectedShipmentID: 'shipmentsContext/getSelectedShipmentID',
        getSelectedShipment: 'shipmentsContext/getSelectedShipment'
      })
    },
    watch: {
      selectedView: {
        deep: true,
        immediate: true,
        handler (val, oldVal) {
          this.$router.push({ path: `/shipments-by-day/${this.getSelectedShipmentID}/${val}` })
        }
      },
      getSelectedShipmentID: {
        immediate: true,
        handler (val) {
          if (val != null) {
            this.$router.push({ path: `/shipments-by-day/${val}/${this.selectedView}` })
          }
        }
      }

    },
  }
</script>

<style lang="scss" scoped>

</style>
